// Collection Product Slider Home page

$(document).ready(function () {
  $(".product_main_media").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor:
      ".thumbnail_beside_main_img .product-single__thumbnails-slider-track",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 1,
          vertical: false,
        },
      },
    ],
  });
  $(
    ".thumbnail_beside_main_img .product-single__thumbnails-slider-track"
  ).slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: ".product_main_media",
    dots: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          vertical: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          slidesToShow: 6,
          vertical: false,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // =============================================================

  // Increase/Decrease quantity buttons
  $(".quantity-plus").click(function () {
    var input = $(this).siblings(".quantity-input");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
      input.val(currentVal + 1);
    }
  });

  // Decrease quantity on "-" button click
  $(".quantity-minus").click(function () {
    var input = $(this).siblings(".quantity-input");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal) && currentVal > 1) {
      input.val(currentVal - 1);
    }
  });

  // Add to Cart button functionality
  $(".add-to-cart").click(function () {
    $(this).addClass("loading");
    var productId = $(this).data("product-id");
    var quantity = $(this)
      .siblings(".product-quantity")
      .find(".quantity-input")
      .val();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: productId,
        quantity: quantity,
      },
      dataType: "json",
      success: function () {
        // window.location.reload();
        $(".go-cart__drawer").addClass("is-open");
        var goCart = new GoCart({
          cartMode: "drawer",
          drawerDirection: "right",
        });
        let loader = setInterval(() => {
          $(".add-to-cart").removeClass("loading");

          clearInterval(loader);
        }, 500);
      },
      error: function () {
        alert("Failed to add product to cart.");
      },
    });
  });

  $(".product-list").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".researched_back_ingredeaints_blocks").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".marquee-track-inner").slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
});

$(document).ready(function () {
  $(".marquee_wrapper").slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
});

$(document).ready(function () {
  $(".faq-item .faq-question-svg").on("click", function () {
    const $item = $(this).closest(".faq-item");
    const $answer = $item.find(".faq-answer");
    const $plusIcon = $item.find(".icon_faq.plus");
    const $minusIcon = $item.find(".icon_faq.minus");

    // Close all other FAQ items
    $(".faq-item")
      .not($item)
      .removeClass("active_content")
      .find(".faq-answer")
      .css("max-height", "");
    $(".faq-item").not($item).find(".icon_faq.plus").show();
    $(".faq-item").not($item).find(".icon_faq.minus").hide();

    // Toggle current FAQ item
    if ($item.hasClass("active_content")) {
      $item.removeClass("active_content");
      $answer.css("max-height", "");
      $plusIcon.show();
      $minusIcon.hide();
    } else {
      $item.addClass("active_content");
      $answer.css("max-height", $answer.prop("scrollHeight") + "px");
      $plusIcon.hide();
      $minusIcon.show();
    }
  });
});

// Select the span element
let spanElement = document.querySelector('.stamped-product-reviews-badge');

// Create the new <a> element
let linkElement = document.createElement('a');
linkElement.href = '#stamped-main-widget'; // Link to the section
linkElement.textContent = '(Write a Review)';
linkElement.classList.add('custom_review'); // Add class

// Insert the <a> element after the span
spanElement.after(linkElement);

// Smooth scroll and show form when clicking the link
linkElement.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Scroll to the target section
    let targetSection = document.getElementById('stamped-main-widget');
    if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
    }

    // Select the form and apply the "stamped-visible" class
    let reviewForm = document.getElementById('new-review-form_2126687895649');
    if (reviewForm) {
        reviewForm.classList.add('stamped-visible');
        reviewForm.style.display = 'block'; // Make sure the form is visible
    }
});




//
// $(document).ready(function () {
//   // Detect when the dropdown value changes
//   $(".single-option-selector-{{ section.id }}").on("change", function () {
//     const selectedValue = $(this).val();

//     // If the "Choose" option is selected, do nothing
//     if (selectedValue === "") {
//       return;
//     }

//     // Trigger the change event to ensure Shopify's variant selection works
//     $(this).trigger("change");
//   });
// });
